import { render, staticRenderFns } from "./MedicoesCubagem.vue?vue&type=template&id=6ca86e28&scoped=true"
import script from "./MedicoesCubagem.vue?vue&type=script&lang=js"
export * from "./MedicoesCubagem.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=6ca86e28&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca86e28",
  null
  
)

export default component.exports